// Date helpers — all dates stored as ISO strings (YYYY-MM-DD) for portability.

export const toISO = (d) => {
  if (!d) return null;
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return null;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const fromISO = (s) => (s ? new Date(s + "T00:00:00") : null);

export const formatDate = (s) => {
  if (!s) return "—";
  const d = fromISO(s);
  if (!d) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
};

export const formatMonth = (s) => {
  if (!s) return "—";
  const d = fromISO(s);
  if (!d) return "—";
  return d.toLocaleDateString("en-US", { month: "short", year: "numeric" });
};

export const monthKey = (s) => {
  const d = typeof s === "string" ? fromISO(s) : s;
  if (!d) return null;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const monthKeyFromDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;

export const addMonths = (date, n) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() + n);
  return d;
};

export const addDays = (date, n) => {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
};

export const startOfMonth = (date) => {
  const d = new Date(date);
  d.setDate(1);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const endOfMonth = (date) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() + 1);
  d.setDate(0);
  d.setHours(23, 59, 59, 999);
  return d;
};

export const monthsBetween = (start, end) => {
  if (!start || !end) return 0;
  const s = start instanceof Date ? start : fromISO(start);
  const e = end instanceof Date ? end : fromISO(end);
  if (!s || !e) return 0;
  return (e.getFullYear() - s.getFullYear()) * 12 + (e.getMonth() - s.getMonth()) + (e.getDate() >= s.getDate() ? 0 : -1);
};

export const daysBetween = (a, b) => {
  const da = a instanceof Date ? a : fromISO(a);
  const db = b instanceof Date ? b : fromISO(b);
  if (!da || !db) return 0;
  return Math.round((db - da) / 86400000);
};

export const today = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

export const monthRange = (startDate, count) => {
  const arr = [];
  const start = startOfMonth(startDate);
  for (let i = 0; i < count; i++) {
    arr.push(addMonths(start, i));
  }
  return arr;
};